export { default as CustomizeView } from './src/customize-view';
